<div class="section-header">
    <h2>{{ 'quizzes.questions.title' | translate }}</h2>
    <p-button
        [label]="'quizzes.questions.add' | translate"
        icon="pi pi-plus"
        [outlined]="true"
        size="small"
        [attr.data-test]="testId() + '-add'"
        (onClick)="add.emit()"
    />
</div>

@if (loading()) {
    <div class="loading-indicator">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (questions().length > 0) {
    <div cdkDropList class="question-list" (cdkDropListDropped)="onDrop($event)">
        @for (question of questions(); track question.id) {
            <div cdkDrag class="question-item">
                <div class="arrows">
                    <button
                        type="button"
                        class="arrow"
                        [disabled]="$first"
                        [attr.data-test]="testId() + '-move-up-' + question.id"
                        (click)="moveQuestion($index, -1)"
                    >
                        <i class="pi pi-chevron-up"></i>
                    </button>
                    <button
                        type="button"
                        class="arrow"
                        [disabled]="$last"
                        [attr.data-test]="testId() + '-move-down-' + question.id"
                        (click)="moveQuestion($index, 1)"
                    >
                        <i class="pi pi-chevron-down"></i>
                    </button>
                </div>
                <span class="text">{{ question.questionText }}</span>
                <span class="answers">{{ question.answers.length }}</span>
                <button type="button" class="remove" [attr.data-test]="testId() + '-remove-' + question.id" (click)="remove.emit($index)">
                    <i class="pi pi-trash"></i>
                </button>
            </div>
        }
    </div>
} @else {
    <p class="empty">{{ 'quizzes.questions.empty' | translate }}</p>
}
